import RestService from '../../contracts/RestService';
import { httpClient } from '../../utils/http-client';
export default class ProjectService extends RestService {
    uri = 'project';
    async updateTranscription(id, changes) {
        const response = await httpClient.post('/video/transcription', {
            id,
            changes
        });
        return response;
    }
    async createDownloadable(projectId, url) {
        const response = await httpClient.post('/project/downloadable', {
            projectId: projectId,
            url: url
        });
        return response;
    }
}
